// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_i6-6";
export var emphasizeQuantity = "_i6-3";
export var flatBottomCorners = "_i6-5";
export var productImage = "_i6-0";
export var quantityContainer = "_i6-2";
export var tooltip = "_i6-1";
export var wrapAndEllipsesOverflow = "_i6-4";